module.exports = __webpack_public_path__ + "static/media/23-skylje.8f31e43e.mp3";